<template>
  <div class="login">
    <!--登录引导-->
    <div class="login-guide" v-if="showGuide">
      <LoginGuidePage />
    </div>
    <div class="title">
      <div class="text">Hello</div>
      <div class="text1">欢迎来到前程乐享</div>
    </div>
    <div class="login-content">
      <!--手机号-->
      <phoneField v-model="phone" />
      <!--验证码-->
      <codeField v-model="code" :phone="phone" ref="codeFieldRef" />
      <!--登录协议-->
      <protocolField v-model="isChecked" isLogin />
      <!--登录按钮-->
      <div
        class="login-btn"
        :class="{ disabled: disabled }"
        @click="handleLogin"
      >
        登录
      </div>
      <div class="serviceIcon" @click="qimoChatClick" v-if="!showGuide">
        <span class="serviceText">联系客服</span>
        <img src="@/assets/style/login-server.png" alt="" />
      </div>
      <Popup
        ref="popup"
        message="请先阅读并同意相关协议"
        confirmText="同意并继续"
        cancelText="不同意"
        @confirm="handleConfirm"
      />
    </div>
  </div>
</template>

<script>
import LoginGuidePage from "@/components/login/loginGuidePage.vue";
import phoneField from "@/components/login/phoneField.vue";
import codeField from "@/components/login/codeField.vue";
import protocolField from "@/components/protocolField/index.vue";
import Popup from "@/components/Popup/index.vue";

import { login, sign } from "@/api/index.js";
export default {
  name: "Login",
  components: {
    LoginGuidePage,
    phoneField,
    codeField,
    protocolField,
    Popup,
  },
  data() {
    return {
      phone: "",
      code: "",
      isChecked: false,
      showGuide: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name !== "agreement") {
        vm.phone = "";
        vm.code = "";
        vm.isChecked = false;
        vm.$refs.codeFieldRef.init();
        vm.showGuide = false;
      }
    });
  },
  async activated() {
    this.showGuide =
      localStorage.getItem("showGuideFlag") != "1" ? true : false;
    if (this.showGuide) {
      setTimeout(() => {
        localStorage.setItem("showGuideFlag", "1");
        this.showGuide = false;
      }, 2000);
    }
  },

  methods: {
    //同意并继续登录
    handleConfirm() {
      this.isChecked = true;
    },
    handleLogin() {
      if (this.disabled) {
        return;
      }
      if (!this.isChecked) {
        this.$refs.popup.showPopup();
        return;
      }
      login({
        phoneNumber: this.phone,
        code: this.code,
        platform: "H5",
      }).then(async (res) => {
        if (res.code === 2000) {
          if (res.data.channelSource == "1") {
            this.$toast("暂未开放，请下载app进行使用");
            return;
          } else {
            this.$store.commit("setToken", res.data.token);
            localStorage.setItem("phone", this.phone);
            //调用签署协议接口
            await sign({
              configIds: this.$store.state.agreementList.map(
                (item) => item.configId,
              ),
            });
            this.$router.push({ name: "Home" });
            localStorage.setItem("actived", 1);
          }
        } else {
          this.$toast(res.msg || res.message || "登录失败");
        }
      });
    },
    qimoChatClick() {
      if (process.env.VUE_APP_ENV === "productionApp") {
        this.$JSBridge.send("serviceType", { type: "8" });
      } else {
        const fromUrl = window.location.href;
        const urlTitle = document.title;
         const clientId = localStorage.getItem("phone") ? `phone_${localStorage.getItem("phone")}` : "";
        window.open(
          `https://ykf-weixin01.7moor.com/wapchat.html?accessId=7db6e8d0-6ed3-11f1-acd0-59b3051d5398&clientId=${clientId}&fromUrl=${fromUrl}&urlTitle=${urlTitle}&language=ZHCN`,
        );
      }
    },
  },
  computed: {
    disabled() {
      return !this.phone || !this.code;
    },
  },
};
</script>

<style scoped lang="scss">
.login {
  position: absolute;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  background-color: #fff;
  overflow-y: auto;
  background-image: url("@/assets/style/home/login-bg.png");
  background-size: 100% 50%;
  background-repeat: no-repeat;
  
}
.title {
  display: flex;
  flex-direction: column;
  margin-top: 116px;
  margin-left: 33px;
  .text {
    /* 1. 设置渐变背景（可以调整角度和颜色） */
    background-image: linear-gradient(180deg, #C45202 0%, #800115 100%);

    /* 2. 将背景裁剪到只有文字的地方 */
    -webkit-background-clip: text;
    background-clip: text;

    /* 3. 把原本的文字颜色设为透明，让底部的背景透出来 */
    -webkit-text-fill-color: transparent;

    /* 补充：为了稳妥，显式将 color 也设为 transparent */
    color: transparent;
    font-size: 32px;
    font-weight: 600;
  }
  .text1 {
    /* 1. 设置渐变背景（可以调整角度和颜色） */
    background-image: linear-gradient(180deg, #C45202 0%, #800115 100%);

    /* 2. 将背景裁剪到只有文字的地方 */
    -webkit-background-clip: text;
    background-clip: text;

    /* 3. 把原本的文字颜色设为透明，让底部的背景透出来 */
    -webkit-text-fill-color: transparent;

    /* 补充：为了稳妥，显式将 color 也设为 transparent */
    color: transparent;
    font-size: 22px;
    font-weight: 600;
  }
}
.login-content {
  margin-top: 30px;
  padding: 20px;
  min-height: 400px;
  background: #fff;
  border-radius: 20px 20px 0px 0px;
}
.login-btn {
  width: 100%;
  height: 52px;
  background: #f24334;
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #fff;
  font-weight: 500;
  margin-top: 20px;
}
.disabled {
  background: #ffc2bd;
}
.serviceIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f24334;
  font-size: 14px;
  margin-top: 30px;
  font-weight: 500;
  img {
    width: 20px;
    height: 20px;
    margin-left: 6px;
  }
}
</style>
